<template>
    <!--<div id="panel_content_envio" class="page_content--envio">
        <div class="button-container">
            <button id="btn_calcular_precio"
                    class="cta_floating_label link link--cta link--cta-left"
                    type="button"
                    @click="enviar">
                <span style="font-family: Heebo; font-weight: normal">Crear orden de reparación</span>
                <div class="square">
                    <v-icon dark>mdi-chevron-right</v-icon>
                </div>
            </button>
        </div>
    </div>

    <div style="padding-left:0;margin-bottom:100px" class="elementor-element elementor-element-8a91ce8 elementor-button-align-start zeleris-btn-black-green zeleris-form-style-1 elementor-widget elementor-widget-form" data-id="8a91ce8" data-element_type="widget" data-settings="{&quot;step_next_label&quot;:&quot;Siguiente&quot;,&quot;step_previous_label&quot;:&quot;Anterior&quot;,&quot;button_width&quot;:&quot;100&quot;,&quot;step_type&quot;:&quot;number_text&quot;,&quot;step_icon_shape&quot;:&quot;circle&quot;}" data-widget_type="form.default">
        <div class="elementor-field-group elementor-column elementor-field-type-submit elementor-col-100 e-form__buttons">
            <v-btn id="btn_calcular_precio" class="elementor-button elementor-size-sm" dark x-large @click="enviar">
                <span class="elementor-button-text" style="font-family: Heebo">Crear orden reparación -</span>
            </v-btn>
        </div>
    </div>-->

    
        <div style="padding-left: 0; margin-bottom: 100px; margin-top: 50px" class="zeleris-shipping-tracking-search-form-action elementor-col-30 zeleris-btn-black-green">
            <button id="btn_calcular_precio" @click="enviar" style="font-family: Heebo;font-size:17px;height:30px;width:300px">
                Crear orden reparación
            </button>
        </div>
    

</template>

<script>

    export default {
        data: () => ({
            formularioSmartLabs: {
                repair: {},
            },
            formularioSmartLabsFinal: {},
        }),
        methods: {
            enviar() {
                this.$bus.resultadosAPI.ordenCreada = "";
                this.$bus.resultadosAPI.subirFactura = "";
                this.$bus.resultadosAPI.generarExpedicion = "";

                //Si no hay errores > formateos y llamadas a API
                if (this.$bus.validarFormulario()) this.precarga();
                //vuelve arriba del todo de la página para mostrar los errores
                else window.scrollTo(0, 0);
            },
            //Llamadas a API
            precarga() {
                this.formularioSmartLabsFinal = this.formularioSmartLabs;

                //recogida/entrega/facturacion
                if (this.$bus.formulario.company) {
                    this.formularioSmartLabsFinal.company = this.$bus.formulario.igualEntrega ? this.$bus.formulario.recogida : this.$bus.formulario.entrega;
                    this.formularioSmartLabsFinal.company.code = this.$bus.formulario.codigoEmpresa;
                } else if (this.$bus.formulario.empresaSinRegistrar) {
                    if (this.$bus.formulario.igualEntrega) {
                        this.formularioSmartLabsFinal.companyClient = this.$bus.formulario.recogida
                    } else {
                        this.formularioSmartLabsFinal.companyClient = this.$bus.formulario.entrega
                        this.formularioSmartLabsFinal.companyClient.name = this.$bus.formulario.recogida.name
                        this.formularioSmartLabsFinal.companyClient.telephone = this.$bus.formulario.recogida.telephone
                        this.formularioSmartLabsFinal.companyClient.mail = this.$bus.formulario.recogida.mail
                    }
                    this.formularioSmartLabsFinal.companyClient.company = this.$bus.formulario.recogida.company;
                    if (this.$bus.formulario.facturaCompleta)
                        this.formularioSmartLabsFinal.fact = this.$bus.formulario.igualFacturacion ? this.$bus.formulario.recogida : this.$bus.formulario.facturacion;
                } else {
                    this.formularioSmartLabs.client = this.$bus.formulario.igualEntrega ? this.$bus.formulario.recogida : this.$bus.formulario.entrega;
                    if (!this.$bus.formulario.igualEntrega) {
                        this.formularioSmartLabs.client.name = this.$bus.formulario.recogida.name
                        this.formularioSmartLabs.client.telephone = this.$bus.formulario.recogida.telephone
                        this.formularioSmartLabs.client.mail = this.$bus.formulario.recogida.mail
                        this.formularioSmartLabs.client.cif = this.$bus.formulario.recogida.cif
                    }
                    if (this.$bus.login) this.formularioSmartLabs.client.login = true; //Particulares registrados
                }

                //dispositivo
                this.formularioSmartLabsFinal.repair.symptom_description = this.$bus.formulario.dispositivo.symptom_description;
                this.formularioSmartLabsFinal.repair.symptom = this.$bus.formulario.dispositivo.symptom;
                this.formularioSmartLabsFinal.repair.prescriptor = this.$bus.formulario.especiales.prescriptor;
                this.formularioSmartLabsFinal.repair.login = this.$bus.$bus.login;
                if (this.$bus.formulario.dispositivo.model2 != "") this.$bus.formulario.dispositivo.model = "";
                this.formularioSmartLabsFinal.device = this.$bus.formulario.dispositivo;

                //logistica
                this.formularioSmartLabsFinal.logistica = this.$bus.formulario.recogida;
                this.formularioSmartLabsFinal.logistica.fecha = this.$bus.formulario.horario.fechaRecogida;
                if (this.$bus.formulario.especiales.embalaje) this.formularioSmartLabsFinal.logistica.embalaje = this.$bus.formulario.especiales.package;

                if (this.$bus.formulario.recogida.enTienda) this.formularioSmartLabsFinal.shop = this.$bus.formulario.recogida.tienda;

                this.$API.newRepair(this.formularioSmartLabsFinal).then((response) => {
                    if (response != "") {
                        this.$bus.resultadosAPI.ordenCreada = response.order;
                        this.guardarFactura();
                    }
                });
            },
            guardarFactura() {
                if (this.$bus.formulario.especiales.invoice.length > 0 && this.$bus.formulario.especiales.invoiceName.length > 0) {
                    this.$bus.jsonFactura.orden = this.$bus.resultadosAPI.ordenCreada;
                    this.$bus.jsonFactura.factura = this.$bus.formulario.especiales.invoice[0];
                    this.$bus.jsonFactura.nombreFactura = this.$bus.formulario.especiales.invoiceName[0];

                    this.$API.guardarFactura(this.$bus.jsonFactura).then((response) => {
                        if (response != "") { this.$bus.resultadosAPI.subirFactura = response.factura; }
                        window.scrollTo(0, 0);
                    });
                } else window.scrollTo(0, 0);
            },
        },
    };
</script>

<style scoped>
    .ml-1 {
        margin-left: 1rem;
    }
</style>